import styled, { css } from 'styled-components';

export const SliderData = styled.div`
  z-index: 999;
  position: relative;
  pointer-events: none;
  border-radius: 3px;
  ${props =>
    props.id === 'roHandle_1' &&
    css`
      ${Hour} {
        background: #26a69a;
      }
    `}
`;

export const Day = styled.div`
  font-size: 10px;
  box-shadow: 0 0 9px 1px rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 3px;
  display: inline-block;
  padding: 4px 9px;
  background: #fff;
  font-weight: 700;
`;

export const Hour = styled.div`
  position: absolute;
  top: 28px;
  left: 50%;
  padding: 11px 8px;
  transform: translate(-50%, 0);
  background: #7e57c2;
  font-size: 11px;
  color: #fff;
  transition: background 0s ease-in;
  box-shadow: 0 0 9px 1px rgba(0, 0, 0, 0.2);
  cursor: move;
  border-radius: 3px;
  z-index: 5;
`;
